import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoggedInGuard } from './guards/logged-in-guard.service';
import { CheckpublicGuard } from './guards/checkpublic.guard';
import { PageNotfoundComponent } from './page-notfound/page-notfound.component';
import { LoginComponent } from './authentication/login/login.component';
import { CalculateAnalyzer } from './calculate/calculate-analyzer.component';

const routes: Routes = [
  {
    path: 'page-not-found',
    component: PageNotfoundComponent
  },
  {
  	path: 'calculate/:order_id',
    component: CalculateAnalyzer
  },
  {
  	path: 'admin',
  	loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  
  {
  	path: '**',
  	component: PageNotfoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
